import { ChangeEvent, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { handleTrack } from '../../../../../utils/tracker';
import { RECAPTCHA_SITE_KEY } from '../../../../Common/ContactSalesForm/constants';
import {
  EmailValidator,
  PhoneValidator,
} from '../../../../ContactSales/utils/validators';
import { drawerFormLead } from './form_lead';
interface ChatbotProps {
  isOpen: boolean;
  toggleIsOpen: () => void;
  partnerName: string;
}

export const DrawerLeadForm: React.FC<ChatbotProps> = ({
  toggleIsOpen,
  isOpen,
  partnerName,
}) => {
  const [formStatus, setFormStatus] = useState({
    loading: false,
    success: false,
    error: '',
  });
  const [formData, setFormData] = useState({
    email: '',
    emailError: '',
    phoneNumber: '',
    phoneNumberError: '',
  });
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const handleStartChat = async () => {
    handleTrack({
      categoryName: partnerName.toLowerCase(),
      valueObj: {
        phoneNumber: formData.phoneNumber,
        email: formData.email,
      },
      label: `chat_request_a_callback`,
      obj: null,
    });
    await drawerFormLead({
      formData,
      setFormStatus,
      recaptchaRef,
    });
  };
  const handleFieldChange =
    (fieldName: string) => (e: ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      // Validate input
      const validate = fieldName == 'email' ? EmailValidator : PhoneValidator;
      const validation = validate(newValue);
      setFormData((prevState) => ({
        ...prevState,
        [fieldName]: newValue,
        [`${fieldName}Error`]: validation.validity ? '' : validation.error,
      }));
    };
  return (
    <div
      className={`w-[353px] bg-white border border-dotted border-grey-250 z-200 h-[calc(100vh-64px)] sm:w-full fixed transition-all duration-300 top-16  flex flex-col ${
        isOpen ? 'right-0' : 'right-[-1000px]'
      }`}
    >
      <div
        id="chatheader"
        className="flex font-bold text-base px-6 py-4 items-center border-b border-dotted border-black"
      >
        <div className="flex items-center flex-grow">
          <div className="mr-3">
            <img src="https://assets.clear.in/cleartax/images/1715246701_aichat.svg" />
          </div>
          <div>Help and support</div>
        </div>
        <div>
          <img
            alt="close"
            src="https://assets.clear.in/cleartax/images/1715246787_group1814219280.svg"
            onClick={() => {
              toggleIsOpen();
              handleTrack({
                label: 'chat-close',
                obj: null,
              });
            }}
            className="cursor-pointer"
          />
        </div>
      </div>
      <ReCAPTCHA
        sitekey={RECAPTCHA_SITE_KEY.commonLead}
        size="invisible"
        ref={recaptchaRef}
      />

      <div className="flex flex-col flex-grow justify-between">
        {!formStatus.success && (
          <div id="chat-content" className="p-6">
            <div className="mb-6 font-medium text-s-14">
              To improve our assistance and address your queries promptly,
              kindly share your email and phone number. This allows us to offer
              tailored support efficiently.
            </div>

            <div className="flex flex-col">
              <div className="mb-6 flex flex-col text-left">
                <label className="font-semibold text-s-14 mb-2">Email</label>
                <input
                  type="email"
                  placeholder="Email"
                  onChange={handleFieldChange('email')}
                  value={formData.email}
                  className="text-s-14 font-medium text-grey-500  w-full px-4 py-2  rounded-sm border border-gray-200 bg-grey-100"
                />
                <p className="text-s-14 text-red-350">{formData.emailError}</p>
              </div>
              <div className="  flex  flex-col  text-left">
                <label className="font-semibold text-s-14  mb-2">
                  Phone number
                </label>
                <input
                  placeholder="Phone Number"
                  onChange={handleFieldChange('phoneNumber')}
                  value={formData.phoneNumber}
                  className="text-s-14 font-medium text-grey-500  w-full px-4 py-2  rounded-sm border border-gray-200 bg-grey-100"
                />
                <p className="text-s-14 text-red-350">
                  {formData.phoneNumberError}
                </p>
              </div>
            </div>
            {formStatus.error && (
              <p className="text-base text-red-350 text-center mt-7">
                {formStatus.error}
              </p>
            )}
          </div>
        )}

        {!formStatus.success && (
          <div id="button-chat" className="p-4">
            <button
              className={`text-s-14 font-bold w-80 h-12 rounded border-none p-0 text-white bg-blue-600 sm:w-full cursor-pointer  ${
                formStatus.loading
                  ? 'opacity-70 cursor-not-allowed'
                  : 'cursor-pointer opacity-100'
              }`}
              disabled={!!formData.phoneNumberError || !!formData.emailError}
              onClick={handleStartChat}
            >
              {formStatus.loading ? 'Please wait...' : 'Request a Callback'}
            </button>
          </div>
        )}

        {formStatus.success && (
          <div className="py-2 items-center flex flex-col">
            <img
              src="https://assets1.cleartax-cdn.com/cleartax/images/1684143111_ezgif.comgifmaker1.webp"
              alt="successfull submission"
              className="mx-auto mb-5"
              width="150"
            />
            <span className="text-s-20 font-bold block text-center mb-8">
              Thank you
            </span>
            <p className="text-base font-medium text-center p-3">
              Our representative will get in touch with you shortly. Meanwhile
              you can talk with our AI for any doubt on your{' '}
              <a
                href="https://cleartax.in/filing/?utm_ref=itr_2024_partner_page_chat"
                target="_blank"
                onClick={() => {
                  handleTrack({
                    categoryName: partnerName.toLowerCase(),
                    label: 'click-chat_link',
                    obj: null,
                  });
                }}
                rel="noreferrer"
              >
                Account Page
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
